import { queryOptions, useQuery } from '@tanstack/react-query'
import getProgramMonitoringPeriods from '../../services/ruutsApi/getProgramMonitoringPeriods'
import { type ProgramMonitoringPeriod } from '../../types/apiModels'
import { queryKeys } from './queryKeys'

type ProgramMonitoringPeriodsQuery = Pick<Partial<ProgramMonitoringPeriod>, 'programId'>

export const programMonitoringPeriodsQueryOptions = ({
  programId,
}: ProgramMonitoringPeriodsQuery) =>
  queryOptions({
    queryKey: queryKeys.programMonitoringPeriods(programId),
    queryFn: ({ signal }) => getProgramMonitoringPeriods({ query: { programId }, signal }),
  })

export const useProgramMonitoringPeriods = ({ programId }: ProgramMonitoringPeriodsQuery = {}) => {
  const result = useQuery({
    ...programMonitoringPeriodsQueryOptions({ programId }),
    // SARA is programId 0, so a truthiness gate would silently disable the query for it.
    enabled: programId != null,
  })

  return {
    programMonitoringPeriods: result.data ?? null,
    isLoading: result.isLoading,
    isError: result.isError,
    error: result.error,
  }
}
